
(function () {
  var SCOPE = '.products';
  var GRID = 'ul.products-list';
  var COUNT = '.cep-pagination-count';

  function sync(scope) {
    var el = scope.querySelector(COUNT);
    if (!el) return;                          
    var grid = scope.querySelector(GRID);
    if (!grid) return;
    var total = parseInt(el.getAttribute('data-cep-total'), 10);
    if (!total) return;                       

    var shown = 0;
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].tagName === 'LI') shown++;
    }
    if (!shown) return;
    if (shown > total) shown = total;          

    var next = shown + ' of ' + total;         
    if (el.textContent.trim() !== next) el.textContent = next;
  }

  function start() {
    var scopes = document.querySelectorAll(SCOPE);
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      sync(scope);
      if (scope.getAttribute('data-cep-count-bound')) continue;
      if (!window.MutationObserver) continue;
      scope.setAttribute('data-cep-count-bound', '1');
      (function (s) {
        new MutationObserver(function () { sync(s); })
          .observe(s, { childList: true, subtree: true });
      }(scope));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());

(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-swatches-swatch');
    if (!swatch) return;

    var card = swatch.closest('.product');
    if (!card) return;

    var image = card.querySelector('.product__image');
    if (!image) return;

    var variantId = swatch.dataset.variantId;

    if (card.dataset.cepSwatch === variantId) return;

    e.preventDefault();
    e.stopPropagation();

    card.dataset.cepSwatch = variantId;
    if (swatch.href) card.dataset.cepSwatchHref = swatch.href;

    var variantImages = image.querySelectorAll('.product-swatches-variant-images-variant-image');
    for (var i = 0; i < variantImages.length; i++) {
      variantImages[i].classList.toggle('active', variantImages[i].dataset.variantId === variantId);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var image = e.target.closest && e.target.closest('.product__image');
    if (!image) return;
    var card = image.closest('.product');
    if (!card || !card.dataset.cepSwatchHref) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = card.dataset.cepSwatchHref;
  }, true);
}());

(function () {
  var MQ = '(min-width: 768px)';

  function ensureMore(list) {
    var more = list.querySelector('.product__swatches-more');
    if (more) return more;
    var card = list.closest('.product');
    var link = card && card.querySelector('a[href*="/products/"]');
    more = document.createElement('a');
    more.className = 'product__swatches-more';
    more.setAttribute('href', link ? link.getAttribute('href') : '#');
    more.setAttribute('data-cep-more', '1');
    list.appendChild(more);
    return more;
  }

  function fit(list) {
    var chips = [].slice.call(list.querySelectorAll('.product__swatches-swatch'));
    if (!chips.length) return;
    var more = list.querySelector('.product__swatches-more');

    chips.forEach(function (c) { c.style.display = ''; });
    if (more) more.style.display = '';

    var styles = window.getComputedStyle(list);
    var width = list.clientWidth
              - (parseFloat(styles.paddingLeft) || 0)
              - (parseFloat(styles.paddingRight) || 0);
    if (width <= 0) return;
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var chipW = chips[0].getBoundingClientRect().width;
    if (!chipW) return;

    var slots = Math.floor((width + gap) / (chipW + gap));
    if (slots < 1) slots = 1;

    if (chips.length <= slots) {
      if (more) more.style.display = 'none';
      return;
    }

    var shown = Math.max(1, slots - 1);
    chips.forEach(function (c, i) { c.style.display = i < shown ? '' : 'none'; });

    more = ensureMore(list);
    more.style.display = '';
    more.textContent = '+ ' + (chips.length - shown);
  }

  var CAROUSEL = '.section-featured-products, .section-product-recommendations';

  function run() {
    if (!window.matchMedia || !window.matchMedia(MQ).matches) {
      document.querySelectorAll('.product__swatches-list').forEach(function (list) {
        if (list.closest(CAROUSEL)) { fit(list); return; }
        list.querySelectorAll('.product__swatches-swatch').forEach(function (c) { c.style.display = ''; });
        var m = list.querySelector('.product__swatches-more');
        if (m) m.style.display = '';
      });
      return;
    }
    document.querySelectorAll('.product__swatches-list').forEach(fit);
  }

  var queued = false;
  var rescan = function () {};
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; rescan(); run(); });
  }

  function start() {
    run();

    var scope = document.querySelector('.section-products') || document.body;
    if (window.MutationObserver && !scope.getAttribute('data-cep-fit-bound')) {
      scope.setAttribute('data-cep-fit-bound', '1');
      new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
    }
    var ro = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    var observed = window.WeakSet ? new WeakSet() : null;
    function observeTiles() {
      if (!ro) return;
      document.querySelectorAll('.product__swatches-list').forEach(function (list) {
        var tile = list.closest('.product') || list;
        if (observed) {
          if (observed.has(tile)) return;
          observed.add(tile);
        }
        ro.observe(tile);
      });
    }
    rescan = observeTiles;
    observeTiles();
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());

(function () {
  function wire(root) {
    if (typeof lazyloading !== 'function') return;
    root.querySelectorAll('.splide__slide--clone .lazy-loading-image:not(.lazy-loaded-image)').forEach(function (fig) {
      if (fig.getAttribute('data-cep-lazy')) return;
      fig.setAttribute('data-cep-lazy', '1');
      lazyloading(fig);
    });
  }
  function start() {
    document.querySelectorAll('.section-slideshow.has-carousel').forEach(function (show) {
      wire(show);
      if (window.MutationObserver) {
        new MutationObserver(function () { wire(show); }).observe(show, { childList: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());

(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.section-header a[href="#"]');
    if (a) e.preventDefault();
  });

  // Off-screen carousel slides are aria-hidden; their links must leave the tab order too.
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function sync(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-cep-tab')) el.setAttribute('data-cep-tab', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-cep-tab')) {
        var t = el.getAttribute('data-cep-tab');
        if (t === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', t);
        el.removeAttribute('data-cep-tab');
      }
    });
  }
  function start() {
    document.querySelectorAll('.splide__slide').forEach(sync);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('splide__slide')) sync(m.target);
        if (m.type === 'childList') m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            if (n.classList.contains('splide__slide')) sync(n);
            n.querySelectorAll && n.querySelectorAll('.splide__slide').forEach(sync);
          }
        });
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

(function () {
  // Suggested products sit in a <template> and are added on first open. Rendering them
  // directly made every page download all their images.
  function fill(dd) {
    var ul = dd.querySelector('.search-dropdown-recommendations-list[data-cep-recs]');
    if (!ul || ul.childElementCount) return;
    var tpl = dd.querySelector('template.cep-recs-tpl') || document.querySelector('template.cep-recs-tpl');
    if (!tpl) return;
    ul.appendChild(tpl.content.cloneNode(true));
    if (typeof lazyloading === 'function') {
      ul.querySelectorAll('.lazy-loading-image').forEach(function (f) { lazyloading(f); });
    }
  }
  function start() {
    document.querySelectorAll('search-dropdown, .search-dropdown').forEach(function (dd) {
      if (dd.classList.contains('active')) fill(dd);
      new MutationObserver(function () { if (dd.classList.contains('active')) fill(dd); })
        .observe(dd, { attributes: true, attributeFilter: ['class'] });
      dd.addEventListener('focusin', function () { fill(dd); });
      dd.addEventListener('pointerenter', function () { fill(dd); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
